import { Pipe, PipeTransform } from '@angular/core';
import { StatusCabecalhoConferenciaDeFatura as Status } from '../../enum/StatusCabecalhoConferenciaDeFatura';

@Pipe({
  name: 'statusConferenciaDeFatura',
})
export class StatusCabecalhoConferenciaDeFaturaPipe implements PipeTransform {
  transform(status: Status): string {
    return status === Status.Fechado ? 'Fechada' : 'Pendente';
  }
}
